export const WHATSAPP_NUMBER = '5585994210413';
export const WHATSAPP_DISPLAY = '(85) 99421-0413';

export const WHATSAPP_1 = '5585994210413';
export const WHATSAPP_1_DISPLAY = '(85) 99421-0413';
export const WHATSAPP_2 = '5585992951348';
export const WHATSAPP_2_DISPLAY = '(85) 99295-1348';

export const STORE_EMAIL = 'babychic.sm@gmail.com';

export const STORE_ADDRESS_LINE1 = 'Av. Maria Gomes de Sá, 1755';
export const STORE_ADDRESS_LINE2 = 'Mondubim — Fortaleza, CE';
export const STORE_MAPS_URL = 'https://maps.app.goo.gl/2fqvsWP8gybTsLo19';

export const STORE_HOURS_WEEKDAY = 'Seg–Sex: 10h às 19h';
export const STORE_HOURS_SATURDAY = 'Sáb: 10h às 18h';
export const STORE_HOURS_SUNDAY = 'Domingo: fechado';
